@if (customerFilter && customerFilter.length > 0) {
  <mat-chip-list
    class="additional-customer-filter-chips__chip-list">
    @for (customer of customerFilter | slice : startFromIndex : customerFilter.length > 60 ? 60 : customerFilter.length; track customer.id || customer.customerUid || customer.fullName || $index) {
      <filter-chip
        [title]="customer.fullName"
        [isMobile]="isMobile"
        (click)="removeClicked.emit(customer)"
        (keydown.enter)="$event.target === $event.currentTarget && removeClicked.emit(customer)">
      </filter-chip>
    }
  </mat-chip-list>
}
@if (customerFilter && customerFilter.length === 0) {
  <div
    class="additional-customer-filter-chips__no-customers-msg">
    <h4>{{noCustomersAvailableMsg}}</h4>
    <h5>Please select another saved group.</h5>
  </div>
}
@if ((isSelectedSavedGroupLarge && customerFilter.length > 0) || customerFilter.length > 60) {
  <div
    class="additional-customer-filter-chips__max-customers-msg"
    [ngClass]="{'additional-customer-filter-chips__mb-max-customers-msg' : isMobile}">
    {{maxCustomersMessage}}
  </div>
}
